module.exports = __webpack_public_path__ + "img/12.34adb3ec.png";